import React from 'react';
import WorkflowExecutionStep from './WorkflowExecutionStep';
import WorkflowDecisionStep from './WorkflowDecisionStep';

const GLYPH = { todo: '', in_progress: '', done: '✓', skipped: '–' };

/**
 * Rend la séquence visible : badge sur le rail + carte. Une décision répondue ouvre
 * une LANE colorée (couloir indenté) contenant la sous-séquence de la branche choisie.
 * Récursion bornée au chemin visible (seules les branches répondues sont rendues).
 */
function Seq({ nodes, answers, runtime, h, busy, readOnly }) {
  const blocks = [];
  (nodes || []).forEach((node, i) => {
    const isFirst = i === 0;
    if (node.type === 'action') {
      const st = runtime[node.id]?.status || 'todo';
      const isLast = i === nodes.length - 1;
      blocks.push(
        <div key={node.id} className={`wf-item ${isFirst ? 'is-first' : ''} ${isLast ? 'is-last' : ''}`}>
          <div className="wf-rail-col"><span className={`wf-badge st-${st}`} aria-hidden>{GLYPH[st]}</span></div>
          <WorkflowExecutionStep
            node={node} state={runtime[node.id] || { status: 'todo' }} busy={busy} readOnly={readOnly}
            onMutate={(action) => h.onMutateStep(node.id, action)}
            onSetNote={(note) => h.onSetNote(node.id, note)}
            onSetCondition={(checked) => h.onSetCondition(node.id, checked)}
          />
        </div>
      );
    } else {
      const chosen = answers[node.id];
      const ans = chosen != null ? (node.answers || []).find((a) => a && a.id === chosen) : null;
      const isLast = i === nodes.length - 1 && !ans;
      blocks.push(
        <div key={node.id} className={`wf-item ${isFirst ? 'is-first' : ''} ${isLast ? 'is-last' : ''}`}>
          <div className="wf-rail-col"><span className={`wf-badge decision ${chosen ? 'answered' : ''}`} aria-hidden>⑂</span></div>
          <WorkflowDecisionStep node={node} chosenAnswerId={chosen || null} busy={busy} readOnly={readOnly}
            onAnswer={(answerId) => h.onAnswer(node.id, answerId)} />
        </div>
      );
      if (ans) {
        blocks.push(
          <div key={`${node.id}-lane`} className="wf-lane" style={{ borderColor: ans.color || 'var(--border-default)' }}>
            <div className="wf-lane-head">
              <span className="wf-lane-label" style={{ background: ans.color || '#64748b' }}>{ans.label || '—'}</span>
            </div>
            <Seq nodes={ans.steps} answers={answers} runtime={runtime} h={h} busy={busy} readOnly={readOnly} />
          </div>
        );
      }
    }
  });
  return <div className="wf-seq">{blocks}</div>;
}

export default function WorkflowTimeline({ execution, busy, readOnly, onMutateStep, onSetNote, onSetCondition, onAnswer }) {
  const nodes = execution.snapshot_steps || [];
  if (nodes.length === 0) {
    return <div className="empty-state"><p>Ce modèle ne contient aucune étape.</p></div>;
  }
  return (
    <Seq
      nodes={nodes}
      answers={execution.answers || {}}
      runtime={execution.runtime_state || {}}
      h={{ onMutateStep, onSetNote, onSetCondition, onAnswer }}
      busy={busy}
      readOnly={readOnly}
    />
  );
}
